module.exports = __webpack_public_path__ + "static/media/19.6c08f981.png";